module.exports = ".btn-circle {\n  padding: 0px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  text-align: center;\n  font-size: 18px;\n  line-height: 36px; }\n\n.btn:disabled {\n  cursor: not-allowed; }\n\n.icon {\n  cursor: pointer; }\n\n.nav-item:not(:last-child) {\n  margin-right: 30px; }\n\n.nav-item:last-child {\n  margin-left: 20px; }\n\napp-errorbar {\n  z-index: 1000; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.scss
// module id = ./src/app/navbar/navbar.component.scss
// module chunks = main